import { WaterSupplyLeftNavsList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Download_Forms = () => (
  <TableStructure
    title="Download Forms"
    heading={false}
    list={[
      {
        fileStoreId: "74574a6c-c90f-4977-a8eb-daaf17294310",
        label: "Application Form For Obtaining Private Water Supply Connection",
      },
    ]}
    columnNo={1}
    leftMenuList={WaterSupplyLeftNavsList}
    longMenuList={true}
  />
);

export default Download_Forms;
